import { Button } from "@mui/material";
import { isEmpty } from "lodash-es";
import { useCallback } from "react";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router";
import { useHandleSave } from "../../../moment/component/buttons/hooks/use-handle-save";

import type { FollowUpButtonsProps } from "./types";
import type { FC } from "react";

export const FollowUpSaveDraftButton: FC<
  Pick<FollowUpButtonsProps, "saveData" | "errors" | "saving" | "onSaving" | "onSaved"> & {
    disabled: boolean;
  }
> = ({ saveData, errors, saving, onSaving, onSaved, disabled }) => {
  const navigate = useNavigate();

  const { callback: save } = useHandleSave({
    reset: () => {},
    validate: () => Promise.resolve(isEmpty(errors.errors)),
  });

  const handleSaveDraft = useCallback(() => {
    onSaving();
    void save(saveData)
      .then(() => {
        onSaved(null);
        if (saveData.follow_up?.id) {
          void navigate(`/follow-up/${saveData.follow_up?.id}`, { replace: true });
        }
        toast.success("Follow-Up saved successfully.");
      })
      .catch((error: Error) => {
        onSaved(error.message);
      });
  }, [saveData, save, onSaving, onSaved, navigate]);

  return (
    <Button
      data-analytics-id="follow-up-save-draft"
      sx={{ ml: 2 }}
      loading={saving}
      variant="outlined"
      disabled={disabled}
      onClick={handleSaveDraft}
      id="saveDraftButton"
    >
      Save
    </Button>
  );
};
